import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { SearchFilled } from '@fluentui/react-icons';
import {
  Input,
  makeStyles,
  Select,
  shorthands,
  useId,
  mergeClasses,
} from '@fluentui/react-components';

const urlPrefixOptions = [
  { key: 'https://', text: 'https://' },
  { key: 'http://', text: 'http://' },
];

const useStyles = makeStyles({
  domainInputWrapper: {
    display: 'flex',
    alignItems: 'center',
    columnGap: '8px',
  },
  prefixSelect: {
    width: '101px',
    minWidth: 'auto',
  },
  domainInput: {
    ...shorthands.flex(1),
  },
  suggestionErrorInvalid: {
    marginTop: '16px',
    color: 'red',
  },
});

export const DomainInputView = (props) => {
  const {
    i18n,
    errorMessage,
    onDomainChange,
    isDomainInvalid,
    errorMessageClassName,
    domainInputWrapperClassName,
  } = props;
  const [urlPrefix, setUrlPrefix] = useState('https://');
  const classes = useStyles();
  const selectId = useId();

  const onSelectChange = useCallback((evt, data) => {
    const { value } = data;
    setUrlPrefix(value);
  }, []);

  const onBlurUrl = useCallback(
    (ev) => {
      const newUrl = ev && ev.target && ev.target.value;
      const prefix = urlPrefixOptions.find(({ key }) => key === urlPrefix).text;
      const newDomain = `${prefix}${newUrl}`;
      onDomainChange(newDomain);
    },
    [onDomainChange, urlPrefix]
  );

  const onKeyDown = useCallback(
    (ev) => {
      if (ev.key === 'Enter') {
        onBlurUrl(ev);
      }
    },
    [onBlurUrl]
  );
  return (
    <>
      <div
        className={mergeClasses(
          classes.domainInputWrapper,
          domainInputWrapperClassName
        )}
      >
        <Select
          id={selectId}
          aria-label={i18n.getString(_TL_('domain'))}
          className={mergeClasses('prefix-select', classes.prefixSelect)}
          onChange={onSelectChange}
        >
          {urlPrefixOptions.map(option => (
            <option key={option.key}>{option.text}</option>
          ))}
        </Select>
        <Input
          className={mergeClasses('domain-input', classes.domainInput)}
          placeholder={i18n.getString(_TL_('Enter your website URL'))}
          contentBefore={<SearchFilled />}
          onBlur={onBlurUrl}
          onKeyDown={onKeyDown}
        />
      </div>
      <div aria-live="polite">
        {isDomainInvalid && (
          <div
            className={mergeClasses(
              'invalid-error',
              classes.suggestionErrorInvalid,
              errorMessageClassName
            )}
          >
            {errorMessage ||
              i18n.getString(_TL_('Please enter a valid Final URL to see images from your website.'))}
          </div>
        )}
      </div>
    </>
  );
};

DomainInputView.propTypes = {
  i18n: PropTypes.shape({}).isRequired,
  isDomainInvalid: PropTypes.bool.isRequired,
  onDomainChange: PropTypes.func.isRequired,
  errorMessage: PropTypes.string,
  errorMessageClassName: PropTypes.string,
  domainInputWrapperClassName: PropTypes.string,
};

DomainInputView.defaultProps = {
  errorMessage: '',
  errorMessageClassName: '',
  domainInputWrapperClassName: '',
};
